export const GET_CART_DATA_LOAD = 'cart/GET_CART_DATA_LOAD';
export const GET_CART_DATA_SUCCESS = 'cart/GET_CART_DATA_SUCCESS';
export const GET_CART_DATA_FAIL = 'cart/GET_CART_DATA_FAIL';

export const UPDATE_CART_LOAD = 'cart/UPDATE_CART_LOAD';
export const UPDATE_CART = 'cart/UPDATE_CART';

export const ADD_TO_CART_LOAD = 'cart/ADD_TO_CART_LOAD';

export const DISCOUNT_CODE_LOAD = 'cart/DISCOUNT_CODE_LOAD';

export const GET_CART_NET_AMOUNT = 'cart/GET_CART_NET_AMOUNT';

export const SHIPPING_CHECK_LOAD = 'cart/SHIPPING_CHECK_LOAD';
export const SHIPPING_CHECK_SUCCESS = 'cart/SHIPPING_CHECK_SUCCESS';
export const SHIPPING_CHECK_FAIL = 'cart/SHIPPING_CHECK_FAIL';

export const FRAME_ONLY_PRODUCT = 'cart/FRAME_ONLY_PRODUCT';
export const LOGOUT_USER = 'cart/LOGOUT_USER';
export const RESET_CART = 'cart/RESET_CART';
